import { createRouter, createWebHistory } from "vue-router";
import store from "@/store"; // Import Vuex store

const routes = [
  {
    path: "/signIn",
    name: "SignIn",
    component: () =>
      import(
        /* webpackChunkName: "SignInView" */ "../views/auth/SignInView.vue"
      ),
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: () =>
  //     import(/* webpackChunkName: "MenuView" */ "../views/menu/MenuView.vue"),
  //   meta: { requiresAuth: true, role: ["admin", "staff", "super_user"] },
  // },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "AnalyticsDashboardView" */ "../views/dashboard/AnalyticsDashboardView.vue"
      ),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/menu",
    name: "Menu",
    component: () =>
      import(/* webpackChunkName: "MenuView" */ "../views/menu/MenuView.vue"),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/orders",
    name: "Orders",
    component: () =>
      import(
        /* webpackChunkName: "TodaysOrdersView" */ "../views/order/TodaysOrdersView.vue"
      ),
    meta: { requiresAuth: true, role: ["admin", "staff", "super_user"] },
  },
  {
    path: "/users",
    name: "Users",
    component: () =>
      import(
        /* webpackChunkName: "AllUsersView" */ "../views/auth/AllUsersView.vue"
      ),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(
        /* webpackChunkName: "AllUsersView" */ "../views/auth/AllUsersView.vue"
      ),
    meta: { requiresAuth: true, role: ["admin", "staff", "super_user"] },
  },
  {
    path: "/reports",
    name: "Reports",
    component: () =>
      import(
        /* webpackChunkName: "ReportsView" */ "../views/reports/ReportsView.vue"
      ),
    meta: { requiresAuth: true, role: ["admin", "super_user"] },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

let authCheckInProgress = false;

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  const userType = store.getters["auth/authUser"]?.type;

  // Only re-validate token if route requires auth and we're not already checking
  if (to.meta.requiresAuth && !authCheckInProgress) {
    authCheckInProgress = true;

    try {
      await store.dispatch("auth/tokenSignIn");
    } catch (error) {
      // If token is invalid, clear auth and redirect to login
      localStorage.removeItem("session_token");
      store.commit("auth/CLEAR_AUTH");
      authCheckInProgress = false;
      return next("/signIn");
    }

    authCheckInProgress = false;
  }

  // Redirect authenticated user away from signIn
  if (to.name === "SignIn" && isAuthenticated) {
    return next("/");
  }

  // Protect routes with role-based access
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      return next("/signIn");
    } else if (to.meta.role && !to.meta.role.includes(userType)) {
      return next({ name: "Orders" });
    }
  }

  next(); // Always call next if you get here
});

export default router;
